import client from './RestClient';

export interface OutboundReportWebService {
  getOutboundReport(): Promise<void>;
}

export const getOutboundReport = async (params: {
  rtbCampaignId: string;
  sellerId: string;
  brandName: string;
  startDate: Date;
  endDate: Date;
}): Promise<void> => {
  const { rtbCampaignId, sellerId, brandName, startDate, endDate } = params;
  const response = await client.post(`/outbound/monitor-report`, {
    advertiserId: '',
    rtbCampaignId: rtbCampaignId,
    sellerId: sellerId,
    webBrandNo: '',
    brandName: brandName,
    adPlatform: '',
    planStatus: '',
    startDate: startDate,
    endDate: endDate,
  });
  return response.data;
};
